import Col from '@visa/vds/col';
import Row from '@visa/vds/row';
import Typography from '@visa/vds/typography';
import React from 'react';
import VSTTOrderSummaryTable from './VSTTOrderSummaryTable';


const VSTTOrderReview = (props) => {
    return (
        <Row className="product-details-row">
            <Col className="product-name-col">
                <Typography tag="h2">Order Summary</Typography>
                <VSTTOrderSummaryTable orderSummaryProductsList={props.order}
                    totalVSTTSetupFee={props.totalVSTTSetupFee} setTotalVSTTSetupFee={props.setTotalVSTTSetupFee}
                    totalVSTTMonthlyFee={props.totalVSTTMonthlyFee} setTotalVSTTMonthlyFee={props.setTotalVSTTMonthlyFee}
                    totalVSTTYearlyFee={props.totalVSTTYearlyFee} setTotalVSTTYearlyFee={props.setTotalVSTTYearlyFee}
                    selectedFeeWaiver={props.selectedFeeWaiver} />
            </Col>
        </Row>
    )
}

export default VSTTOrderReview